import React from 'react';
import * as _ from 'lodash';
import WorkScheduleService from '../../services/Works';
import {
  WORKER_TYPES,
  SCHEDULE_STATUS,
  PRIVATE_PARTNER_COMPANY_FLAG,
} from '../../utilities/constants';

/**
 * ダイアログのコンポーネント
 * 【表示項目の全人工合計】ボタン
 */
class WorkScheduleManHours extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractorTotal: 0,
      contractorEarly: 0,
      contractorLate: 0,
      hireTotal: 0,
      hireEarly: 0,
      hireLate: 0,
    };
  }

  componentDidMount() {
    const params = this.props.mergedSearchParams;

    if (
      _.isUndefined(params.dayworker_type) ||
      params.dayworker_type === String(WORKER_TYPES.contractor.id)
    ) {
      const contract = {
        ...params,
        schedule_flag: SCHEDULE_STATUS.schedule.id,
        dayworker_type: WORKER_TYPES.contractor.id,
        private_partner_company_flag: PRIVATE_PARTNER_COMPANY_FLAG.noPrivate.id,
      };
      WorkScheduleService.groupWorkHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorTotal: response.data.entities.work.man_hours,
          });
        }
      );
      WorkScheduleService.groupEarlyHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorEarly: response.data.entities.work.early_hours,
          });
        }
      );
      WorkScheduleService.groupOverHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorLate: response.data.entities.work.over_hours,
          });
        }
      );
    }
    if (
      _.isUndefined(params.dayworker_type) ||
      params.dayworker_type === String(WORKER_TYPES.regular.id)
    ) {
      const hire = {
        ...params,
        schedule_flag: SCHEDULE_STATUS.schedule.id,
        dayworker_type: WORKER_TYPES.regular.id,
        private_partner_company_flag: PRIVATE_PARTNER_COMPANY_FLAG.noPrivate.id,
      };
      WorkScheduleService.groupWorkHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireTotal: response.data.entities.work.man_hours });
        }
      );
      WorkScheduleService.groupEarlyHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireEarly: response.data.entities.work.early_hours });
        }
      );
      WorkScheduleService.groupOverHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireLate: response.data.entities.work.over_hours });
        }
      );
    }
  }

  render() {
    const showContractType =
      _.isUndefined(this.props.mergedSearchParams.dayworker_type) ||
      this.props.mergedSearchParams.dayworker_type ===
        String(WORKER_TYPES.contractor.id);
    const showRegularType =
      _.isUndefined(this.props.mergedSearchParams.dayworker_type) ||
      this.props.mergedSearchParams.dayworker_type ===
        String(WORKER_TYPES.regular.id);

    return (
      <div className='dialog dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>表示項目の全人工合計</span>
        </div>
        <div className='dialog__body scroll'>
          <div className='dashboard dashboard--dialog'>
            <div className='dashboard__wrapper contents__vertical'>
              {showContractType ? (
                <div className='dashboard__section'>
                  <div className='dashboard__section-title'>請負合計</div>
                  <div className='dashboard__boards'>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>人工</div>
                      <div className='value'>{this.state.contractorTotal}</div>
                    </div>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>早/残</div>
                      <div className='value'>
                        {this.state.contractorEarly}/{this.state.contractorLate}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {showRegularType ? (
                <div className='dashboard__section'>
                  <div className='dashboard__section-title'>常傭合計</div>
                  <div className='dashboard__boards'>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>人工</div>
                      <div className='value'>{this.state.hireTotal}</div>
                    </div>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>早/残</div>
                      <div className='value'>
                        {this.state.hireEarly}/{this.state.hireLate}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
        <div className='dialog__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.onClose();
            }}
          >
            戻る
          </button>
        </div>
      </div>
    );
  }
}

export default WorkScheduleManHours;



// WEBPACK FOOTER //
// ./src/components/modals/WorkScheduleManHours.jsx